module.exports = __webpack_public_path__ + "static/media/14.0cee18a4.jpeg";